<div class="header-background">
  <img class="header-logo" [src]="logos.medium" alt="RiPSIM Technologies Inc." />
  <div class="mt-2" style="position: fixed; top: 40px; left: 50%; transform: translate(-50%, -50%)">
    <span class="section-name">{{ pageName$ | async }}</span>
  </div>
</div>
<p-menubar [model]="(menuItems$ | async) ?? undefined" [autoDisplay]="true" (mouseover)="activateHover()" (mouseleave)="hideMenu()">
  <p-button i18n-label label="Logout" styleClass="logout-button mr-2" icon="pi pi-fw pi-sign-out" (onClick)="onLogout()"></p-button>
</p-menubar>
<div class="footer-bar">
  <div class="footer-content">
    &copy;
    <rs-copyright-component />
  </div>
  <div class="footer-logo"><img [src]="logos.small" alt="" aria-hidden="true" /></div>
</div>
